/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ min: NonNullable<unknown>, max: NonNullable<unknown> }} Age_RangeInputs */

const th_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`อายุ ${i?.min}–${i?.max} ปี`)
};

const en_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ages ${i?.min}–${i?.max}`)
};

const ja_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}〜${i?.max}歳`)
};

const zh_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} 至 ${i?.max} 岁`)
};

const es_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`De ${i?.min} a ${i?.max} años`)
};

const pt_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`De ${i?.min} a ${i?.max} anos`)
};

const id_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} sampai ${i?.max} tahun`)
};

const fr_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`De ${i?.min} à ${i?.max} ans`)
};

const tl_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} hanggang ${i?.max} taong gulang`)
};

const vi_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} đến ${i?.max} tuổi`)
};

const ko_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min}세부터 ${i?.max}세까지`)
};

const de_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} bis ${i?.max} Jahre`)
};

const ru_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`От ${i?.min} до ${i?.max} лет`)
};

const tr_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} ile ${i?.max} yaş arası`)
};

const it_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Da ${i?.min} a ${i?.max} anni`)
};

const pl_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Od ${i?.min} do ${i?.max} lat`)
};

const uk_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Від ${i?.min} до ${i?.max} років`)
};

const hi_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} से ${i?.max} वर्ष`)
};

const ar_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`من ${i?.min} إلى ${i?.max} سنة`)
};

const ms_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} hingga ${i?.max} tahun`)
};

const bn_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} থেকে ${i?.max} বছর`)
};

const zh_tw2_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} 至 ${i?.max} 歲`)
};

const zh_hk2_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} 至 ${i?.max} 歲`)
};

const ur_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} سے ${i?.max} سال`)
};

const fa_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} تا ${i?.max} سال`)
};

const sw_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Miaka ${i?.min} hadi ${i?.max}`)
};

const nl_age_range = /** @type {(inputs: Age_RangeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.min} tot ${i?.max} jaar`)
};

/**
* | output |
* | --- |
* | "Ages {min}–{max}" |
*
* @param {Age_RangeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const age_range = /** @type {((inputs: Age_RangeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Age_RangeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_age_range(inputs)
	if (locale === "ja") return ja_age_range(inputs)
	if (locale === "zh") return zh_age_range(inputs)
	if (locale === "es") return es_age_range(inputs)
	if (locale === "pt") return pt_age_range(inputs)
	if (locale === "id") return id_age_range(inputs)
	if (locale === "fr") return fr_age_range(inputs)
	if (locale === "tl") return tl_age_range(inputs)
	if (locale === "vi") return vi_age_range(inputs)
	if (locale === "ko") return ko_age_range(inputs)
	if (locale === "de") return de_age_range(inputs)
	if (locale === "ru") return ru_age_range(inputs)
	if (locale === "tr") return tr_age_range(inputs)
	if (locale === "it") return it_age_range(inputs)
	if (locale === "pl") return pl_age_range(inputs)
	if (locale === "uk") return uk_age_range(inputs)
	if (locale === "hi") return hi_age_range(inputs)
	if (locale === "ar") return ar_age_range(inputs)
	if (locale === "ms") return ms_age_range(inputs)
	if (locale === "bn") return bn_age_range(inputs)
	if (locale === "zh-TW") return zh_tw2_age_range(inputs)
	if (locale === "zh-HK") return zh_hk2_age_range(inputs)
	if (locale === "ur") return ur_age_range(inputs)
	if (locale === "fa") return fa_age_range(inputs)
	if (locale === "sw") return sw_age_range(inputs)
	if (locale === "nl") return nl_age_range(inputs)
	return en_age_range(inputs)
});